import { takeLatest, put, call } from 'redux-saga/effects';

import { sendErrorToSentry } from '../logging';
import { getCountry as getCountryFromProvider } from '../shared/providers/LocationProvider';
import {
  COUNTRY_REQUEST,
  COUNTRY_REQUEST_ERROR,
  countryRequestSuccess,
  countryRequestError,
  COUNTRY_UPDATE
} from '../actionCreators/locationActions';
import { LOCATION_SESSION_STORAGE_KEY } from '../config/config';
import { RESET_STATE } from '../actionCreators/generalActions';

function* getCountry() {
  try {
    let countryData = yield call(getCountryFromProvider);
    yield put(countryRequestSuccess(countryData));
  } catch (err) {
    sendErrorToSentry(err);
    yield put(countryRequestError(err));
  }
}

function storeLocation({ country, currency, isoCode3 }) {
  sessionStorage.setItem(
    LOCATION_SESSION_STORAGE_KEY,
    JSON.stringify({
      country,
      currency,
      isoCode3
    })
  );
}

function clearStoredLocation() {
  sessionStorage.removeItem(LOCATION_SESSION_STORAGE_KEY);
}

function* locationSagas() {
  yield takeLatest(COUNTRY_REQUEST, getCountry);
  yield takeLatest(COUNTRY_REQUEST_ERROR, sendErrorToSentry);
  yield takeLatest(COUNTRY_UPDATE, storeLocation);
  yield takeLatest(RESET_STATE, clearStoredLocation);
}

export default locationSagas;
